import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import content from '../../content.json';

export function Footer() {
  return (
    <footer className="bg-muted/50 border-t border-border" data-testid="footer">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 font-bold text-xl mb-4">
              <span className="text-foreground">DakshTechInfo</span>
            </Link>
            <p className="text-muted-foreground text-sm max-w-md">
              {content.footer.description}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              {content.navigation.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    data-testid={`footer-link-${item.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <a
              href={`mailto:${content.contact.info.email}`}
              className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
              data-testid="footer-email"
            >
              <Mail className="h-4 w-4" />
              {content.contact.info.email}
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            {content.footer.copyright}
          </p>
          <div className="flex gap-6">
            {content.footer.links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                data-testid={`footer-legal-${link.name.toLowerCase().replace(/[^a-z]/g, '-')}`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
